module.exports = __webpack_public_path__ + "img/46.340b1cbd.jpg";